(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_slide"] && !Shopify.designMode) return;
  try {
    /**
   * Drives a muted, looping YouTube background video.
   *
   * A plain `loop=1` embed shows YouTube's end-screen (suggested videos with
   * navigation arrows) at the loop boundary. Using the IFrame API we restart the
   * video shortly before it ends, so that end-screen never renders. Vimeo
   * backgrounds use `background=1` and need none of this.
   *
   * @extends HTMLElement
   */
  class AxBgVideo extends HTMLElement {
    /** @type {number} Invalidates pending async boots across connect/disconnect (DOM moves). */
    #token = 0;
    /** @type {HTMLIFrameElement | null} */
    #iframe = null;
    /** @type {object | null} The YT.Player instance. */
    #player = null;
    /** @type {number | null} */
    #interval = null;
    /** @type {number | null} Safety timer that reveals the video even if the play event is missed. */
    #revealTimer = null;
    /** @type {MutationObserver | null} Waits for observer-CFH to set a lazy src. */
    #srcObserver = null;

    /** @type {Promise<object> | null} Shared, lazily-loaded YouTube IFrame API. */
    static apiPromise = null;

    connectedCallback() {
      this.#token += 1;
      const token = this.#token;

      this.#iframe = this.querySelector('iframe[data-video-type="youtube"]');
      if (!this.#iframe) return;

      if (this.#iframe.getAttribute('src')) {
        this.#boot(token);
        return;
      }

      // Lazy slide: wait for observer-CFH to promote lazy-src -> src.
      this.#srcObserver = new MutationObserver(() => {
        if (this.#iframe && this.#iframe.getAttribute('src')) {
          this.#srcObserver?.disconnect();
          this.#srcObserver = null;
          this.#boot(token);
        }
      });
      this.#srcObserver.observe(this.#iframe, { attributes: true, attributeFilter: ['src'] });
    }

    disconnectedCallback() {
      this.#token += 1;
      this.#srcObserver?.disconnect();
      this.#srcObserver = null;

      if (this.#interval) {
        clearInterval(this.#interval);
        this.#interval = null;
      }

      if (this.#revealTimer) {
        clearTimeout(this.#revealTimer);
        this.#revealTimer = null;
      }

      this.classList.remove('is-ready');

      if (this.#player) {
        try {
          this.#player.destroy();
        } catch (error) {
          /* player already torn down */
        }
        this.#player = null;
      }
    }

    /**
     * @param {number} token - The connection token captured at boot time.
     */
    async #boot(token) {
      const YT = await AxBgVideo.loadApi();

      // Bail if we were disconnected / moved, or already booted.
      if (!YT || token !== this.#token || !this.isConnected || this.#player || !this.#iframe) return;

      this.#player = new YT.Player(this.#iframe, {
        events: {
          onReady: (event) => {
            event.target.mute();
            event.target.playVideo();
            this.#guardLoop(event.target);
            // Safety net: reveal even if the PLAYING event never reaches us.
            this.#revealTimer = setTimeout(() => this.#reveal(), 2000);
          },
          onStateChange: (event) => {
            // 1 = playing: only reveal now, once YouTube's load chrome is gone.
            if (event.data === YT.PlayerState.PLAYING) this.#reveal();
            if (event.data === YT.PlayerState.ENDED) {
              event.target.seekTo(0);
              event.target.playVideo();
            }
          },
        },
      });
    }

    /** Fades the playing video in over the poster. */
    #reveal() {
      this.classList.add('is-ready');
    }

    /**
     * Restarts the video just before it ends so the end-screen never shows.
     * @param {object} player - The YT.Player instance.
     */
    #guardLoop(player) {
      this.#interval = setInterval(() => {
        if (!this.#player) return;

        let duration;
        let current;
        try {
          duration = player.getDuration();
          current = player.getCurrentTime();
        } catch (error) {
          return;
        }

        if (duration > 0 && current >= duration - 0.6) {
          try {
            player.seekTo(0);
            player.playVideo();
          } catch (error) {
            /* player not ready */
          }
        }
      }, 250);
    }

    /**
     * Loads the YouTube IFrame API once and resolves with the global `YT`.
     * @returns {Promise<object>}
     */
    static loadApi() {
      if (AxBgVideo.apiPromise) return AxBgVideo.apiPromise;

      AxBgVideo.apiPromise = new Promise((resolve) => {
        if (window.YT && window.YT.Player) {
          resolve(window.YT);
          return;
        }

        const previous = window.onYouTubeIframeAPIReady;
        window.onYouTubeIframeAPIReady = () => {
          if (typeof previous === 'function') previous();
          resolve(window.YT);
        };

        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        document.head.appendChild(tag);
      });

      return AxBgVideo.apiPromise;
    }
  }

  if (!customElements.get('ax-bg-video')) {
    customElements.define('ax-bg-video', AxBgVideo);
  }
  } catch(e) { console.error(e); }
})();

})();
